import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const useSpots = () => {
  const [spots, setSpots] = useState(null);
  useEffect(() => {
    api.get("/spots").then(({ data }) => setSpots(data)).catch(() => setSpots(null));
  }, []);
  return spots;
};

export const SpotsMeter = ({ compact = false }) => {
  const spots = useSpots();
  if (!spots) return null;
  const pct = (spots.claimed / spots.total) * 100;
  return (
    <div data-testid="free-spots-counter-badge" className={`glass-card ${compact ? "p-4" : "p-5"} max-w-md`}>
      <div className="flex items-center justify-between gap-4">
        <span className="inline-flex items-center gap-2 text-sm font-bold text-white">
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-qi-emerald opacity-75" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-qi-emerald" />
          </span>
          <span data-testid="free-spots-remaining">{spots.remaining}</span>&nbsp;of {spots.total} free founding spots left
        </span>
        <span className="font-mono text-[11px] text-white/40">{spots.claimed} claimed</span>
      </div>
      <div className="h-2 bg-white/10 rounded-full mt-3 overflow-hidden">
        <div className="h-full bg-gradient-to-r from-qi-pink to-qi-emerald rounded-full transition-[width] duration-700" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};
